import { AnimatedImage, AnimatedImageProps } from '@unistocks/components/basic/image';
import { ASSET_DEFAULT_DARK, ASSET_DEFAULT_LIGHT } from '@unistocks/shared/consts';
import { useIsDarkMode } from '@unistocks/shared/hooks/use-active-color-scheme';
import React from 'react';

export const UnistocksCircle: React.FC<AnimatedImageProps> = props => {
  const isDarkMode = useIsDarkMode();
  const imgSrc = isDarkMode ? ASSET_DEFAULT_DARK : ASSET_DEFAULT_LIGHT;

  return <AnimatedImage source={imgSrc} {...props} />;
};
